import { FormatMessageType } from '@hooks/useValidation';
import { REQUIRED_FIELD } from '@utils/validation/validation.constant';
import Yup from '@utils/validation/yup-extended';

import { Coordinates } from '@/types/commons/commons.types';

export const coordinatesSchema = (formatMessage: FormatMessageType) => {
  return Yup.object<Coordinates>().shape({
    latitude: Yup.number()
      .required(formatMessage({ id: REQUIRED_FIELD }, { field: formatMessage({ id: 'global.latitude' }) }))
      .transform((value, originalValue) => (originalValue === '' ? null : value))
      .min(-90, formatMessage({ id: 'form.latitude' }))
      .max(90, formatMessage({ id: 'form.latitude' })),
    longitude: Yup.number()
      .required(formatMessage({ id: REQUIRED_FIELD }, { field: formatMessage({ id: 'global.longitude' }) }))
      .transform((value, originalValue) => (originalValue === '' ? null : value))
      .min(-180, formatMessage({ id: 'form.longitude' }))
      .max(180, formatMessage({ id: 'form.longitude' })),
  });
};
